<template>
  <div class="card survey-question" :class="{active: active, 'non-active': !active}">
    <div class="card--container">
      <h3>{{number}}. {{question.question}}</h3>
      <v-radio-group v-model="question.answer" class="row questions" :row="row" @change="next">
        <div>
          <v-radio class="radio" label="Strongly disagree" value="1" />
          <v-radio class="radio" label="Disagree" value="2" />
          <v-radio class="radio" label="Somewhat disagree" value="3" />
          <v-radio class="radio" label="Neither agree nor disagree" value="4" />
        </div>
        <div>
          <v-radio class="radio" label="Somewhat agree" value="5" />
          <v-radio class="radio" label="Agree" value="6" />
          <v-radio class="radio" label="Strongly agree" value="7" />
        </div>
      </v-radio-group>
    </div>
  </div>
</template>

<script>

export default {
  props: ["number", "question", "active"],
  data() {
    return {
      row: true,
    };
  },
  methods: {
    next() {
      this.$emit("next", this.number);
    },
  },
};
</script>

<style lang="less" scoped>
.survey-question {
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.active {
    background-color: white !important;
    opacity: 1 !important;
  }
  &.non-active {
    background-color: white !important;
    opacity: .7 !important;
  }
  .questions {
    .radio {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      font-size: 40px !important;
      padding: 15px;
    }
    .radio:hover {
      background-color: lightgray;
    }
    .v-input--radio-group__input {
      flex-direction: column !important;
    }

   .v-label {
      font-size: 30px !important;
    }
    div {
      margin-right: 20px;

    }
  }
  h3 {
    font-size: 24px;
    font-weight: 300;
    color: #70a4ff;
  }

};

</style>
